// Module
var code = "<h2 class=\"interiorSectionHeading align-center mb-2rem\">Reduced Payment Bill Breakdown</h2> ";
// Exports
export default code;